// app/src/services/Professionals/ProfessionalsService.js

import api from '../api';
import { addNonceToData } from '../NonceService';

const ProfessionalsService = {
	professionalCreate: async (data, config = {}) => {
		const dataWithNonce = await addNonceToData(data);
		return api.post(`/professionalCreate`, dataWithNonce, config);
	},
	proOrPartReadByEmail: async (email, config = {}) => {
		const dataWithNonce = await addNonceToData({email});
		return api.post(`/proOrPartReadByEmail`, dataWithNonce, config);
	},
	professionalUpdateDocument: async (id, data, config = {}) => {
		const dataWithNonce = await addNonceToData({professionalID: id, data});
		return api.post(`/professionalUpdateDocument`, dataWithNonce, config);
	},
};

export default ProfessionalsService;
